import { render } from "./ChatHistoryList.vue?vue&type=template&id=051112f0"
import script from "./ChatHistoryList.vue?vue&type=script&lang=js"
export * from "./ChatHistoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__